import React from "react";
import "./ContentHeader.scss";

interface ContentHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode[];
}

const ContentHeader: React.FC<ContentHeaderProps> = ({ title, description, actions }) => {
  return (
    <div className="content-header">
      <div className="content-header__left">
        <h1 className="content-header__title">{title}</h1>
        {description && <p className="content-header__desc">{description}</p>}
      </div>
      {actions && actions.length > 0 && (
        <div className="content-header__actions">
          {actions.map((action, i) => (
            <React.Fragment key={i}>{action}</React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentHeader;
